import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import Item from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/BankOfHoursPanel/TimeBreakdown/components/Item'
import ItemsBox from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/BankOfHoursPanel/TimeBreakdown/components/ItemsBox'
import { WorkedTimeData } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/Worked/lib/calculateWorkedTime'

interface Props {
  workedTimeData: WorkedTimeData
}

const EffectiveTime = ({ workedTimeData }: Props) => {
  const { absencesMinutes, minutes } = workedTimeData

  return (
    <ItemsBox
      label={i18n.t('clock_in.sidepanel.worked_hours.effective_time.title')}
      minutes={absencesMinutes + minutes}
      description={i18n.t('clock_in.sidepanel.worked_hours.effective_time.description')}
    >
      <Item label={i18n.t('clock_in.sidepanel.worked_hours.title')} minutes={minutes} />
      <Item
        label={i18n.t('clock_in.sidepanel.accordion.paid_absences.title')}
        minutes={absencesMinutes}
      />
    </ItemsBox>
  )
}

export default EffectiveTime
